import {
  en_default
} from "./chunk.MAS2SHYD.js";

// src/utilities/localize.ts
import { LocalizeController as DefaultLocalizationController, registerTranslation } from "@shoelace-style/localize";
import { registerTranslation as registerTranslation2 } from "@shoelace-style/localize";
var LocalizeController = class extends DefaultLocalizationController {
};
registerTranslation(en_default);

export {
  LocalizeController,
  registerTranslation2 as registerTranslation
};
